module.exports = __webpack_public_path__ + "static/media/Cardo-Bold.6a1523ec.ttf";